import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import LocaleActions from "modules/i18n/locale-actions";
import { Locales } from "modules/i18n/locale-config";
import { getLocale } from "modules/i18n/locale-selectors";
import { getBrand } from "../brand/brand-selectors";

class LocaleSwitcher extends Component {
  static propTypes = {
    locale: PropTypes.string,
    changeLocale: PropTypes.func.isRequired,
    passedClass: PropTypes.string,
    availableLocales: PropTypes.array.isRequired
  };

  render() {
    const { changeLocale, locale, passedClass, availableLocales } = this.props;

    return (
      <div className={`LocaleSwitcher ${passedClass || ""}`}>
        <div className="LocaleSwitcher__Title">
          <FormattedMessage id={"locale-switcher.title"} />
        </div>
        <select onChange={e => changeLocale(e.target.value)} value={locale}>
          {availableLocales.map(locale => (
            <option value={locale.code} key={locale.code}>
              <FormattedMessage id={locale.labelId} />
            </option>
          ))}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: getLocale(state),
  availableLocales: getBrand(state).supportedLanguages || Locales
});

const mapDispatchToProps = {
  changeLocale: LocaleActions.Creators.localeChanged
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocaleSwitcher);



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-switcher.js